import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";
//import _ from 'lodash';

class ConceptsSearch extends Component {
	render() {
		const { concepts } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>
			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={concepts.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	_submitSearch() {
		const {concepts} = this.props;
		this.props.conceptsShow(1,concepts.filters);
	}

	_searchChange(event){
		this.props.change('concepts.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('concepts.filters');
		this.props.conceptsShow(1);
	}
}

export default SecureLayout(ConceptsSearch);



// WEBPACK FOOTER //
// ./src/elements/concepts/widget/concepts_search.jsx